






















































































































import {Component, Vue} from 'vue-property-decorator';
import {
  入庫返品薬価差集計依頼型,
  納入価表示区分型,
  入庫返品薬価差明細型,
  薬価差ソート区分型,
  入庫返品薬価差集計依頼バリデータ一覧,
} from '@/type/stock/receive/price_diff';
import { 商品区分型 } from '@/type/master/item';
import {ValidationResult} from '@/type/validation/result';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';

import StockItemClassSelector from '@/components/stock/item/StockItemClassSelector.vue';
import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import moment from 'moment';

@Component({
  components: {
    YearMonthPicker,
    StockItemClassSelector,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    WholesaleSelector,
  },
})
export default class ListStockReceivePriceDiff extends Vue {
  private アラートメッセージ: string | string[] | null = null;

  private 入庫返品薬価差集計依頼: 入庫返品薬価差集計依頼型 = this.集計条件初期値();
  private 入庫返品薬価差明細一覧: 入庫返品薬価差明細型[] = [];
  private 選択中の行index: number | null = null;

  private 集計条件バリデーション結果: ValidationResult = new ValidationResult(入庫返品薬価差集計依頼バリデータ一覧);

  private created(): void {
    moment.locale('ja');
    this.initialize();
  }

  private initialize() {
    this.入庫返品薬価差集計依頼 = this.集計条件初期値();
    this.入庫返品薬価差明細一覧 = [];
    this.アラートメッセージ = null;
  }

  private 集計条件初期値(): 入庫返品薬価差集計依頼型 {
    return {
      入庫年月From: moment().format('YYYY-MM'),
      入庫年月To: moment().format('YYYY-MM'),
      卸コード: null,
      納入価表示区分: 納入価表示区分型.仕入時,
      メーカー名: '',
      商品名カナ: '',
      商品区分: null,
      表示順: 薬価差ソート区分型.メーカー名,
    };
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private async 集計する(): Promise<void> {
    await api.入庫返品薬価差を集計する(this.入庫返品薬価差集計依頼)
      .then((response: any) => {
        this.入庫返品薬価差明細一覧 = response.入庫返品薬価差集計結果一覧;
        if (this.入庫返品薬価差明細一覧.length === 0) {
          this.アラートメッセージ = '該当の入庫は存在しません';
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
        this.$modal.show('アラート');
      });
  }

  private async 集計するハンドラ(): Promise<void> {
    if (this.集計条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.集計条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.集計する);
  }

  private async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.集計条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.集計条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('出力ダイアログ');
  }

  private async 出力する(): Promise<void> {
    await download.入庫返品薬価差照会一覧表を出力する('入庫返品薬価差照会一覧.xlsx', this.入庫返品薬価差集計依頼)
            .catch((error: any) => {
              this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
              this.$modal.show('アラート');
            });
    this.ダイアログを閉じる('出力ダイアログ');
  }

  private async 出力するハンドラ(): Promise<void> {
    await progress(this.出力する);
  }

  private クリアする(): void {
    this.initialize();
    this.ダイアログを閉じる('クリアダイアログ');
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 入力エラー判定(項目名: string): boolean {
    return this.集計条件バリデーション結果.hasError(項目名);
  }

  private beforeUpdate(): void {
    this.集計条件バリデーション結果.validate(this.入庫返品薬価差集計依頼);
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }
}
